export default __webpack_public_path__ + "static/media/AvenirNext-Medium.70d133bb.otf";